import { render, staticRenderFns } from "./Actives.vue?vue&type=template&id=f2848956&scoped=true"
import script from "./Actives.vue?vue&type=script&lang=js"
export * from "./Actives.vue?vue&type=script&lang=js"
import style0 from "./Actives.vue?vue&type=style&index=0&id=f2848956&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f2848956",
  null
  
)

export default component.exports